/**
 * Constants for the requests helper.
 */
const SOURCE = null
// const SOURCE = 'support-dashboard' // Enable support for this.
const DEFAULT_ERROR_MESSAGE = 'There was a problem on our side.'
const HEADER_ACCESS_KEY = 'X-ACCESS-TOKEN'
const responseCodes = {
    SUCCESS: 1,
    ERROR: 0,
    EMPTY: 2
}

export {
    SOURCE, DEFAULT_ERROR_MESSAGE, responseCodes, HEADER_ACCESS_KEY
}
